import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/contexts/LanguageContext";
import { ArrowLeft, Mail, MessageSquare, Clock } from "lucide-react";

const CONTENT = {
  it: {
    title: "Contatti",
    back: "Torna alla home",
    intro: "Hai una domanda, un suggerimento o hai bisogno di assistenza con una valutazione? Siamo felici di aiutarti. ReValue è un progetto indipendente dedicato a chi rivende l'usato in modo intelligente: leggiamo ogni messaggio e rispondiamo nel più breve tempo possibile.",
    cards: [
      { icon: "mail", h: "Email", p: "Scrivici per qualsiasi richiesta, segnalazione o collaborazione.", v: "info@re-value.net" },
      { icon: "msg", h: "Supporto", p: "Problemi con una stima o con il generatore di annunci? Descrivici il caso e l'oggetto valutato per un aiuto mirato.", v: "info@re-value.net" },
      { icon: "clock", h: "Tempi di risposta", p: "Rispondiamo di norma entro 1-2 giorni lavorativi, dal lunedì al venerdì.", v: "Lun - Ven" },
    ],
    note: "Per richieste relative ai tuoi dati personali (accesso, rettifica, cancellazione ai sensi del GDPR) indica l'email del tuo account. Non inviare dati sensibili o password via email.",
  },
  en: {
    title: "Contact",
    back: "Back to home",
    intro: "Got a question, a suggestion, or need help with a valuation? We're happy to help. ReValue is an independent project dedicated to people who resell second-hand items smartly: we read every message and reply as soon as we can.",
    cards: [
      { icon: "mail", h: "Email", p: "Write to us for any request, report or collaboration.", v: "info@re-value.net" },
      { icon: "msg", h: "Support", p: "Issues with an estimate or the listing generator? Describe the case and the valued item for targeted help.", v: "info@re-value.net" },
      { icon: "clock", h: "Response time", p: "We usually reply within 1-2 business days, Monday to Friday.", v: "Mon - Fri" },
    ],
    note: "For requests about your personal data (access, rectification, erasure under GDPR) please state your account email. Do not send sensitive data or passwords by email.",
  },
};

const ICONS = { mail: Mail, msg: MessageSquare, clock: Clock };

export default function Contact() {
  const { lang } = useLang();
  const c = CONTENT[lang] || CONTENT.it;

  return (
    <main data-testid="contact-page" className="bg-white">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12">
        <Link to="/" data-testid="contact-back" className="inline-flex items-center gap-2 font-mono text-xs font-bold tracking-widest text-[#4A4A4A] hover:text-black">
          <ArrowLeft size={14} /> {c.back}
        </Link>
        <span className="block overline text-[#002FA7] mt-6">LEGAL / CONTACT</span>
        <h1 className="font-display font-black text-4xl sm:text-5xl tracking-tighter mt-2">{c.title}</h1>
        <p className="text-base text-[#4A4A4A] leading-relaxed mt-5 max-w-2xl">{c.intro}</p>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-4">
          {c.cards.map((card) => {
            const Icon = ICONS[card.icon];
            return (
              <article key={card.h} className="border border-black p-5">
                <Icon size={22} className="text-[#002FA7]" />
                <h2 className="font-display font-black text-xl tracking-tight mt-4">{card.h}</h2>
                <p className="text-sm text-[#4A4A4A] leading-relaxed mt-2">{card.p}</p>
                <a href={card.v.includes("@") ? `mailto:${card.v}` : undefined} className="inline-block mt-3 font-mono text-sm font-bold text-[#002FA7] break-all">{card.v}</a>
              </article>
            );
          })}
        </div>

        <p className="text-sm text-[#737373] leading-relaxed mt-8 border-l-2 border-black pl-5">{c.note}</p>
      </div>
    </main>
  );
}
